import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LOGO_URL, BRAND } from '@/mocks/brandData';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/services' },
  { label: 'About', href: '/about' },
  { label: 'San Antonio', href: '/location' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [pathname]);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${scrolled ? 'bg-white/98 backdrop-blur-lg shadow-[0_1px_0_rgba(0,0,0,0.06)]' : 'bg-transparent'}`}>
      <div className="px-6 md:px-10 flex items-center justify-between h-[72px] md:h-[80px]">

        <Link to="/" aria-label="JC Cooks Home" className="flex items-center">
          <img
            src={LOGO_URL}
            alt="JC Cooks Catering & Chef Service"
            className={`h-9 w-auto object-contain transition-all duration-500 ${scrolled ? '' : 'brightness-0 invert'}`}
          />
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`relative text-[11px] font-semibold tracking-[0.16em] uppercase whitespace-nowrap transition-colors duration-300 group ${
                pathname === link.href
                  ? 'text-jc-gold'
                  : scrolled
                  ? 'text-jc-charcoal hover:text-jc-gold'
                  : 'text-white/85 hover:text-white'
              }`}
            >
              {link.label}
              <span className={`absolute -bottom-1 left-0 h-px bg-jc-gold transition-all duration-300 ${pathname === link.href ? 'w-full' : 'w-0 group-hover:w-full'}`} />
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3 md:gap-5">
          <a
            href={BRAND.phoneHref}
            className={`hidden lg:flex items-center gap-2 text-[13px] font-medium whitespace-nowrap transition-colors duration-300 ${scrolled ? 'text-jc-charcoal hover:text-jc-gold' : 'text-white/80 hover:text-white'}`}
          >
            <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 ${scrolled ? 'bg-jc-gold/10' : 'bg-white/10'}`}>
              <i className="ri-phone-line text-jc-gold text-xs"></i>
            </div>
            {BRAND.phone}
          </a>

          <a
            href="#quote"
            className={`hidden md:inline-flex items-center px-5 py-2.5 text-[10px] font-bold tracking-[0.15em] uppercase rounded-full transition-all duration-300 whitespace-nowrap ${
              scrolled
                ? 'bg-jc-charcoal text-white hover:bg-jc-gold hover:text-jc-charcoal'
                : 'bg-jc-gold text-jc-charcoal hover:bg-white hover:text-jc-charcoal'
            }`}
          >
            Request a Quote
          </a>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full transition-all ${scrolled ? 'text-jc-charcoal bg-jc-cream' : 'text-white bg-white/10'}`}
            aria-label="Toggle menu"
          >
            <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100">
          <div className="px-6 py-5 flex flex-col gap-0.5">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`py-3.5 text-[11px] font-semibold tracking-[0.15em] uppercase border-b border-gray-100 last:border-0 transition-colors ${pathname === link.href ? 'text-jc-gold' : 'text-jc-charcoal'}`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-5 flex flex-col gap-3">
              <a href={BRAND.phoneHref} className="flex items-center gap-2 text-jc-charcoal font-medium text-sm">
                <i className="ri-phone-line text-jc-gold"></i>
                {BRAND.phone}
              </a>
              <a href="#quote" className="inline-flex items-center justify-center py-3 bg-jc-gold text-jc-charcoal text-[10px] font-bold tracking-[0.15em] uppercase rounded-full whitespace-nowrap">
                Request a Quote
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
